<template>
    <div class='menu-wrapper'>

        <template v-for="item in routes" >
            <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
                <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
                    <a href="javascript:void(0)" :title="item.children[0].name">
                        <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                    </a>
                    <span slot="title">{{item.children[0].name}}</span>
                </el-menu-item>
            </router-link>
            <el-submenu :index="item.name" v-if="!item.noDropdown&&!item.hidden" :class="{'menu-center': isShrinkage}" :id="item.authority">
                <template slot="title">
                    <a href="javascript:void(0)" :title="item.name">
                        <icon-svg v-if='item.icon' :icon-class="item.icon" :class="{'clear-margin': isShrinkage}"></icon-svg>
                    </a>

                    <span :class="{'hide-el': isShrinkage}">{{item.name}}</span>
                </template>
                <template v-for="child in item.children" v-if='!child.hidden'>
                    <sidebar-item class='nest-menu' v-if='child.children&&child.children.length>0' :routes='[child]'> </sidebar-item>

                    <router-link v-else :to="item.path+'/'+child.path">
                        <el-menu-item :index="item.path+'/'+child.path" :class="[{'menu-item-width': isShrinkage},'switch-el-menu-item']" :id="child.path" ref="child_el_menu_item">
                            <a href="javascript:void(0)" :title="child.name">
                                <icon-svg v-if='child.icon' :icon-class="child.icon" :class="{'clear-margin': isShrinkage}"></icon-svg>
                            </a>
                            <span :class="{'offset-margin': isShrinkage}">{{child.name}}</span>
                        </el-menu-item>
                    </router-link>

                </template>

            </el-submenu>

        </template>
        <!-- <el-menu-item class="menu-toggle" index='bottom'>
			<svg aria-hidden="true" class="svg-icon svg-slide-icon" @click="toggleSildeBar">
				<use xlink:href="#icon-hamburger"></use>
			</svg>
		</el-menu-item> -->
    </div>
</template>

<script>
export default {
    name: "SidebarItem",
    props: {
        routes: {
            type: Array
        }
    },
    data() {
        return {
            toggleMer: true,
            active_id: undefined,
            userPhone: localStorage.getItem("phone"),
            userType: localStorage.getItem("userType")
        };
    },
    created() {
        //  console.log(this.routes);

        this.toggleMer =
            this.userPhone === "13501189583" ||
            this.userPhone === "15018955912"
                ? false
                : true;
    },
    mounted() {
        if (this.userType === "10") {
            $("#fund").hide();
        }
    },
    computed: {
        isShrinkage() {
            return this.$store.state.app.isShrinkage;
        }
    },
    methods: {

    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.menu-logo-wrapper {
    overflow: hidden;
    &::after {
        background-color: transparent;
    }
}
.switch-img {
    width: 45px;
    height: 45px;
    cursor: pointer;
}
.menu-logo {
    height: 78px;
    background: rgba(82, 114, 233, 1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-left: none;
    color: #fff;
    overflow: hidden;
    margin-bottom: 4px;
    position: relative;

    .unipay-div,
    .mipay-div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #5272e9;
        padding-left: 14px;
        // box-shadow: 0 2px 3px rgba(0,0,0,.23);
    }

    // .mipay-div {
        // top: -78px;
    // }

    .logo-img {
        float: left;
        width: 50px;
        height: 50px;
        margin: 14px 6px;
    }
    .logo-shrink-img {
        margin-right: 27px;
        margin-left: 10px;
    }
    .divide-line {
        float: left;
        width: 1px;
        height: 33px;
        margin: 22px 7px 22px 0px;
        background-color: #fff;
        &::after {
            background-color: transparent;
        }
    }
    .logo-system {
        float: left;
        font-size: 36px;
        color: #fff;
        line-height: 78px;
        &::after {
            background-color: transparent;
        }
    }
}

// .menu-toggle{
// 	position: absolute;
// 	bottom: 0;
// 	right: 0;
// 	border-left: none;
// 	height: 70px;
// 	width: 223px;
// 	line-height: 70px;
// 	text-align: right;
// 	background-color: #5272e9;
// 	cursor: auto;
// }

.hide-el {
    display: none;
}
.clear-margin {
    margin: 0;
}
.menu-center {
    text-align: center;
}
.menu-item-width {
    min-width: 100px !important;
}
.offset-margin {
    margin-left: 60px;
}
</style>



// WEBPACK FOOTER //
// SidebarItem.vue?71724c0e